module.exports = __webpack_public_path__ + "website/img/Yoyo_C_01.4d43c576.jpeg";